import React from "react";
import "./iconbutton.css";

function IconButton({
  label,
  pressed,
  hasPopup,
  expanded,
  controls,
  className,
  onClick,
  id,
  children,
}) {
  return (
    <button
      type="button"
      id={id}
      className={className ? `icon-button ${className}` : "icon-button"}
      aria-label={label}
      aria-pressed={
        pressed === undefined || pressed === null ? undefined : Boolean(pressed)
      }
      aria-haspopup={hasPopup || undefined}
      aria-expanded={
        expanded === undefined || expanded === null
          ? undefined
          : Boolean(expanded)
      }
      aria-controls={controls || undefined}
      onClick={onClick}
    >
      <span className="icon-button-content">{children}</span>
    </button>
  );
}

export default IconButton;
